import React from "react";
import images from "../../../utilities/images/images";
import {
  formatPrice,
  getDiscountPercent,
  getFinalAmount,
  hasPackageDiscount,
} from "../utils/coursePricing";
import { isVariantPackage, isPackagePurchased, shouldShowBuyNow } from "../utils/explorePackage";
import { getExploreCourseAnchorId } from "../utils/exploreCoursesScrollRestore";
import { getExploreCardClassName } from "../utils/exploreCardHighlight";
import PackageBottomNote from "./PackageBottomNote";
import "./PackageBottomNote.css";
import "./dashboardExploreCard.css";
import "./TopperChoiceCard.css";

const TOPPER_SHELL_THEMES = [
  { shell: "dashboard-topper-card--purple", icon: "dashboard-topper-card__icon--purple" },
  { shell: "dashboard-topper-card--cyan", icon: "dashboard-topper-card__icon--cyan" },
];

const TopperChoiceCard = ({
  course,
  section = "topper",
  themeIndex = 0,
  highlightedAnchorId = null,
  onDetails,
  onBuy,
  onOpenVariants,
}) => {
  const theme = TOPPER_SHELL_THEMES[themeIndex % TOPPER_SHELL_THEMES.length];
  const finalAmount = getFinalAmount(course?.amount, course?.discount);
  const showDiscount = hasPackageDiscount(course?.amount, course?.discount);
  const discountLabel = getDiscountPercent(course?.amount, course?.discount);
  const isPurchased = isPackagePurchased(course);
  const showBuyNow = shouldShowBuyNow(course);
  const isVariant = isVariantPackage(course);

  const anchorId = course?.package_id
    ? getExploreCourseAnchorId(course.package_id, section)
    : undefined;
  const isSelected = Boolean(anchorId && highlightedAnchorId === anchorId);

  return (
    <article
      className={`${getExploreCardClassName(`dashboard-topper-card ${theme.shell}`, anchorId, highlightedAnchorId)}`}
      id={anchorId}
      aria-current={isSelected ? "true" : undefined}
    >
      {course?.enrolled_animation ? (
        <div
          className="dashboard-topper-card__banner"
          dangerouslySetInnerHTML={{ __html: course.enrolled_animation }}
        />
      ) : null}

      <div className="dashboard-topper-card__body">
        <div className="dashboard-topper-card__header">
          <div className={`dashboard-topper-card__icon ${theme.icon}`} aria-hidden="true">
            <img
              src={images.topperChoiceStar}
              alt=""
              className="dashboard-topper-card__star"
            />
          </div>
          <h3 className="dashboard-topper-card__title">{course?.package_name || "—"}</h3>
        </div>

        <div className="dashboard-topper-card__price-row">
          <div className="dashboard-topper-card__prices">
            <strong>{formatPrice(finalAmount)}</strong>
            {showDiscount ? (
              <span className="dashboard-topper-card__strike">
                {formatPrice(course.amount)}
              </span>
            ) : null}
          </div>
          {discountLabel ? (
            <span className="dashboard-topper-card__discount">{discountLabel}</span>
          ) : null}
        </div>

        <div
          className={`dashboard-topper-card__actions${
            isPurchased ? " dashboard-topper-card__actions--purchased" : ""
          }`}
        >
          {isPurchased ? (
            <button
              type="button"
              className="dashboard-topper-card__btn dashboard-topper-card__btn--primary"
              onClick={onDetails}
            >
              View Course
            </button>
          ) : (
            <button
              type="button"
              className="dashboard-topper-card__btn dashboard-topper-card__btn--outline"
              onClick={onDetails}
            >
              Course details
            </button>
          )}
          {!showBuyNow ? null : (
            <button
              type="button"
              className="dashboard-topper-card__btn dashboard-topper-card__btn--primary"
              onClick={onBuy}
            >
              Buy Now
              {isVariant ? (
                <img
                  src={images.downArrow}
                  alt=""
                  className="dashboard-topper-card__btn-icon"
                  aria-hidden="true"
                />
              ) : null}
            </button>
          )}
        </div>

        <PackageBottomNote
          course={course}
          onOpenVariants={onOpenVariants}
          className="dashboard-topper-card__bottom-note"
        />
      </div>
    </article>
  );
};

export default TopperChoiceCard;
